import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import api, {
  UpdateStoreManagementProductCommand,
  ProductTableSortField,
  SortOrder,
  ProductStatus,
} from 'api';

interface ProductSliceState {}

const initialState: ProductSliceState = {};

interface GetStoreProductsModel {
  pageNumber: number;
  pageSize: number;
  sortField: ProductTableSortField;
  sortOrder: SortOrder;
  status?: ProductStatus;
}
export const getStoreProducts = createAsyncThunk(
  'product/getStoreProducts',
  async ({
    pageNumber,
    pageSize,
    sortField,
    sortOrder,
    status,
  }: GetStoreProductsModel) => {
    return api.getStoreManagementProducts(
      pageNumber,
      pageSize,
      sortField,
      sortOrder,
      status,
    );
  },
);

export const getUploadLink = createAsyncThunk(
  'product/getUploadLink',
  async (fileName: string) => {
    return api.getUploadLink(fileName);
  },
);

interface UpdateProductModel {
  id: string;
  data: UpdateStoreManagementProductCommand;
}
export const updateStoreManagementProduct = createAsyncThunk(
  'product/updateStoreManagementProduct',
  async ({ id, data }: UpdateProductModel) => {
    return api.updateStoreManagementProduct(id, data);
  },
);

export const getStoreManagementProductDetails = createAsyncThunk(
  'product/getStoreManagementProductDetails',
  async (id: string) => {
    return api.getStoreManagementProductDetails(id);
  },
);

const productSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {},
  extraReducers: (builder) => {},
});

const { reducer } = productSlice;

export default reducer;
